import * as React from 'react';

import { getConfig } from '@constants';

import { ELineSeparator } from '@enums';

import { SplitText } from '@common/components/SplitText';

import { IMultilineTextProps } from './types';

const breakRegex = new RegExp('\\{%mobile_break%\\}|\\{%desktop_break%\\}', 'g');

export const MultilineText: React.FC<IMultilineTextProps> = (props) => {
	const { shouldSplitByWord, text, wordClassName } = props;
	const { isMobile } = getConfig();
	const separator = isMobile ? ELineSeparator.MOBILE : ELineSeparator.DESKTOP;

	return (
		<React.Fragment>
			{separator.length === 0 || text.length < separator.length || !text.includes(separator)
				? text.replace(breakRegex, '')
				: text.split(separator).map((fragment, index, array) => (
					<React.Fragment key={fragment}>
						{shouldSplitByWord ? (
							<SplitText
								text={fragment.replace(breakRegex, '')}
								wordClassName={wordClassName}
							/>
						) : (
							fragment.replace(breakRegex, '')
						)}
						{index !== array.length - 1 &&
							<br/>
						}
					</React.Fragment>
				))
			}
		</React.Fragment>
	);
};
